import { Button, Grid, Paper, TextField, styled } from "@material-ui/core";
import { Alert, Backdrop, Box, CircularProgress, CssBaseline, FormControl, InputLabel, MenuItem, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../Constants";
import AddIcon from "@mui/icons-material/Add"
import Modal from "../modal/Modal";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs"
import daysjs, { Dayjs } from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import { axiosClient } from "../AxiosClient";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const ButtonEdit = styled(Button)({
    color: '#161e55',
    '&:hover': {
        color: '#A8C8AF'
    }
})


const urlApi = API_URL;

export default function Fondeador() {

    const titles = ['id', 'Nombre', 'Contrato', 'Rentabilidad', 'Tiempo', 'Rendimientos', ""];
    const contracts = ["MANDATO", "MUTUO"]
    const [data, setData] = useState();
    const [details, setDetails] = useState();
    const [numberPage, setNumberPage] = useState(0);
    const [isModal, setIsModal] = useState(false);
    const [name, setName] = useState("");
    const [tipoContrato, setTipoContrato] = useState("");
    const [valorInicial, setValorInicial] = useState("");
    const [rentabilidad, setRentabilidad] = useState("");
    const [fechaDeInicio, setFechaDeInicio] = useState();
    const [plazo, setPlazo] = useState("");
    const [fechaDeFinalizacion, setFechaDeFinalizacion] = useState();
    const [pagoDeRendimientos, setPagoDeRendimientos] = useState("");
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");
    const [newItem, setNewItem] = useState("");
    const [isModalEdit, setIsModalEdit] = useState(false);
    const [nameEdit, setNameEdit] = useState("");
    const [tipoContratoEdit, setTipoContratoEdit] = useState("");
    const [valorInicialEdit, setValorInicialEdit] = useState("");
    const [rentabilidadEdit, setRentabilidadEdit] = useState("");
    const [fechaDeInicioEdit, setFechaDeInicioEdit] = useState();
    const [plazoEdit, setPlazoEdit] = useState("");
    const [fechaDeFinalizacionEdit, setFechaDeFinalizacionEdit] = useState();
    const [pagoDeRendimientosEdit, setPagoDeRendmientosEdit] = useState("");
    const [openBackdropEdit, setOpenBackdropEdit] = useState(false);
    const [openSnackbarEdit, setOpenSnackbarEdit] = useState(false);
    const [messageEdit, setMessageEdit] = useState("");
    const [severityEdit, setSeverityEdit] = useState("");
    const [newItemEdit, setNewItemEdit] = useState("");
    const [dataItem, setDataItem] = useState({});
    const [editFondeadorId, setEditFondeadorId] = useState("");
    const rowsPerPage = 10;
    
    const handleChangePage = (event, newPage) => {
        setNumberPage(newPage)
        axiosClient.get(`/v1/fondeadores`, {
            params: {
                size: rowsPerPage,
                page: newPage,
                sort: 'id,asc'
            }
        })
        .then(response => {
            setDetails(response.data);
            setData(response.data.content);
        })
        .catch(error => {
            console.log('Error: ' + error.message);
        });
    }

    const handleAddButton = () => {
        setIsModal(true)
    }

    const handleClosedModal = () => {
        setIsModal(!isModal)
        setName("")
        setTipoContrato("")
        setValorInicial("")
        setRentabilidad("")
        setFechaDeInicio()
        setPlazo("")
        setFechaDeFinalizacion()
        setPagoDeRendimientos("")
    }

    const handleChangeName = (event) => {
        setName(event.target.value)
    }

    const handleChangeTipoContrato = (event) => {
        setTipoContrato(event.target.value)
    }

    const handleChangeRentabilidad = (event) => {
        setRentabilidad(event.target.value)
    }

    const handleChangeValorInicial = (event) => {
        setValorInicial(event.target.value)
    }

    const handleChangeFechaDeInicio = (value) => {
        setFechaDeInicio(value)
    }

    const handleChangePlazo = (event) => {
        setPlazo(event.target.value)
    }

    const handleChangeFechaDeFinalizacion = (value) => {
        setFechaDeFinalizacion(value)
    }

    const handleChangePagoDeRendimientos = (event) => {
        setPagoDeRendimientos(event.target.value)
    }

    const handleClosedSnack = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setOpenSnackbar(false)
    }

    const handleSubmitAdd = (event) => {
        event.preventDefault()
        const body = {
            name: name,
            tipoContrato: tipoContrato,
            rentabilidad: rentabilidad,
            valorInicial: valorInicial,
            fechaDeInicio: daysjs(`${fechaDeInicio?.$d?.getFullYear()}-${fechaDeInicio?.$d?.getMonth()+1}-${fechaDeInicio?.$D}`).format('YYYY-MM-DD'),
            plazo: plazo,
            fechaDeFinalizacion: daysjs(`${fechaDeFinalizacion?.$d?.getFullYear()}-${fechaDeFinalizacion?.$d?.getMonth()+1}-${fechaDeFinalizacion?.$D}`).format('YYYY-MM-DD'),
            pagoDeRendimientos: pagoDeRendimientos
        }
        console.log(body.fechaDeInicio)
        setOpenBackdrop(true)
        axiosClient.post('/v1/fondeadores', body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            handleClosedModal();
            setOpenBackdrop(false);
            setOpenSnackbar(true);
            setMessage("Se creó exitosamente el fondeador");
            setTimeout(() => setSeverity("success"), 5000);
            setNewItem(name + tipoContrato);
        })
        .catch(error => {
            setOpenBackdrop(false);
            setOpenSnackbar(true);
            setMessage("Error en la creación del fondeador");
            setSeverity("error");
            console.log('Error: ' + error);
        });
    }

    const handleEdit = (fondeadorId) => {
        setIsModalEdit(true)
        setEditFondeadorId(fondeadorId)
        axiosClient.get(`/v1/fondeadores/${fondeadorId}`)
        .then(response => {
            setDataItem(response.data);
            setNameEdit(response.data.name);
            setTipoContratoEdit(response.data.tipoContrato);
            setValorInicialEdit(response.data.valorInicial);
            setRentabilidadEdit(response.data.rentabilidad);
            setFechaDeInicioEdit(daysjs(response.data.fechaDeInicio));
            setPlazoEdit(response.data.plazo);
            setFechaDeFinalizacionEdit(daysjs(response.data.fechaDeFinalizacion));
            setPagoDeRendmientosEdit(response.data.pagoDeRendimientos);
        })
        .catch(error => {
            console.log('Error: ' + error.message);
        });
    }

    const handleClosedEdit = () => {
        setIsModalEdit(!isModalEdit)
        setNameEdit("")
        setTipoContratoEdit("")
        setValorInicialEdit("")
        setEditFondeadorId("")
        setRentabilidadEdit("")
        setFechaDeInicioEdit()
        setPlazoEdit("")
        setFechaDeFinalizacionEdit()
        setPagoDeRendmientosEdit("")
    }

    const handleChangeEditName = (event) => {
        setNameEdit(event.target.value)
    }

    const handleChangeEditTipoContrato = (event) => {
        setTipoContratoEdit(event.target.value)
    }

    const handleChangeEditValorInicial = (event) => {
        setValorInicialEdit(event.target.value)
    }

    const handleChangeEditRentabilidad = (event) => {
        setRentabilidadEdit(event.target.value)
    }

    const handleChangeEditFechaDeInicio = (value) => {
        setFechaDeInicioEdit(value)
    }

    const handleChangeEditPlazo = (event) => {
        setPlazoEdit(event.target.value)
    }

    const handleChangeEditFechaDeFinalizacion = (value) => {
        setFechaDeFinalizacionEdit(value)
    }

    const handleChangeEditPagoDeRendimientos = (event) => {
        setPagoDeRendmientosEdit(event.target.value)
    }

    const handleSubmitEdit = (event) => {
        event.preventDefault()
        setOpenBackdropEdit(true)
        const body = {
            name: nameEdit,
            tipoContrato: tipoContratoEdit,
            valorInicial: valorInicialEdit,
            rentabilidad: rentabilidadEdit,
            fechaDeInicio: daysjs(`${fechaDeInicioEdit?.$d.getFullYear()}-${fechaDeInicioEdit?.$d.getMonth()+1}-${fechaDeInicioEdit?.$D}`),
            plazo: plazoEdit,
            fechaDeFinalizacion: daysjs(`${fechaDeFinalizacionEdit?.$d.getFullYear()}-${fechaDeFinalizacionEdit?.$d.getMonth()+1}-${fechaDeFinalizacionEdit?.$D}`),
            pagoDeRendimientos: pagoDeRendimientosEdit
        }
        axiosClient.patch(`/v1/fondeadores/${editFondeadorId}`, body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            handleClosedEdit();
            setOpenBackdropEdit(false);
            setOpenSnackbarEdit(true);
            setMessageEdit("Se editó exitosamente el fondeador");
            setTimeout(() => setSeverityEdit("success"), 5000);
            setNewItemEdit(nameEdit + tipoContratoEdit);
        })
        .catch(error => {
            setOpenBackdropEdit(false);
            setOpenSnackbarEdit(true);
            setMessageEdit("Error en la edición del fondeador");
            setSeverityEdit("error");
            console.log('Error: ' + error.message);
        });
    }

    const handleClosedSnakcbarEdit = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setOpenSnackbarEdit(false)
    }

    useEffect(() => {
        axiosClient.get('/v1/fondeadores', {
            params: {
                size: rowsPerPage,
                page: numberPage,
                sort: 'id,asc'
            }
        })
        .then(response => {
            setData(response.data.content);
            setDetails(response.data);
        })
        .catch(error => {
            console.log('Error: ' + error.message);
        });
    }, [newItem, newItemEdit])

    return (
        <React.Fragment>
            <CssBaseline></CssBaseline>
            <Toolbar></Toolbar>
            <Box sx={{width: '100%', margin: '0px 14px'}}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container>
                        <Grid item xs={6}>
                            <Box display={'flex'}>
                                <h1>Fondeadores</h1>
                                <Box display={'flex'} alignItems={'center'}>
                                    <ButtonAdd onClick={handleAddButton}><AddIcon></AddIcon></ButtonAdd>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {titles.map(title => (
                                            <TableCell key={title} align="center">{title}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data ? data?.map(fondeador => (
                                        <TableRow key={fondeador.id} sx={{'&:last-child td, &:last-child th': { border: 0 }}}>
                                            <TableCell align="center">{fondeador.id}</TableCell>
                                            <TableCell align="center">{fondeador.name}</TableCell>
                                            <TableCell align="center">{fondeador.tipoContrato}</TableCell>
                                            <TableCell align="center">{fondeador.rentabilidad}</TableCell>
                                            <TableCell align="center">
                                                {fondeador.fechaDeInicio}
                                                <br/>
                                                {fondeador.fechaDeFinalizacion}
                                            </TableCell>
                                            <TableCell align="center">{fondeador.pagoDeRendimientos}</TableCell>
                                            <TableCell align="center"><ButtonEdit onClick={() => handleEdit(fondeador.id)}><EditIcon></EditIcon></ButtonEdit></TableCell>
                                        </TableRow>
                                    )) : <TableRow>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                        </TableRow>}
                                </TableBody>
                            </Table>
                            <TablePagination 
                            rowsPerPageOptions={[rowsPerPage]}
                            count={(details?.totalElements)}
                            rowsPerPage={rowsPerPage}
                            page={numberPage}
                            onPageChange={handleChangePage}
                            />
                        </TableContainer>
                    </Grid>
                </Stack>
            </Box>
            {isModal &&
                <Modal activeModal={isModal} handleModal={handleClosedModal}>
                    <Box textAlign={'center'}>
                        <h2>Creación de fondeadores</h2>
                    </Box>
                    <Box width={'80%'} margin={'1rem auto'}>
                        <form onSubmit={handleSubmitAdd}>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="name" label="Nombre" variant="outlined" value={name} onChange={handleChangeName}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="tipo-contrato">Tipo de contrato</InputLabel>
                                    <Select labelId="tipo-contrato" id="tipoContrato" label="Tipo de contrato" value={tipoContrato} onChange={handleChangeTipoContrato}>
                                        {contracts.map(contrato => (
                                            <MenuItem key={contrato} value={contrato}>{contrato}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="valor-inicial" label="Valor inicial" variant="outlined" value={valorInicial} onChange={handleChangeValorInicial}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="rentabilidad" label="Rentabilidad" variant="outlined" value={rentabilidad} onChange={handleChangeRentabilidad}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de inicio" value={fechaDeInicio} onChange={handleChangeFechaDeInicio}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="plazo" label="Plazo" variant="outlined" value={plazo} onChange={handleChangePlazo}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de finalización" value={fechaDeFinalizacion} onChange={handleChangeFechaDeFinalizacion}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="pago-de-rendimientos" label="Pago de rendimientos" variant="outlined" value={pagoDeRendimientos} onChange={handleChangePagoDeRendimientos}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={2} textAlign={'center'}>
                                <ButtonAdd type="submit">Crear fondeador</ButtonAdd>
                            </Box>
                        </form>
                    </Box>
                </Modal>
            }
            {isModalEdit && 
                <Modal activeModal={isModalEdit} handleModal={handleClosedEdit}>
                    <Box textAlign={'center'}>
                        <h2>Edición de fondeadores</h2>
                    </Box>
                    <Box width={'80%'} margin={'1rem auto'}>
                        <form onSubmit={handleSubmitEdit}>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="name" label="Nombre" variant="outlined" value={nameEdit} onChange={handleChangeEditName}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="tipo-contrato">Tipo de contrato</InputLabel>
                                    <Select labelId="tipo-contrato" id="tipoContrato" label="Tipo de contrato" value={tipoContratoEdit} onChange={handleChangeEditTipoContrato}>
                                        {contracts.map(contrato => (
                                            <MenuItem key={contrato} value={contrato}>{contrato}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="valor-inicial" label="Valor inicial" variant="outlined" value={valorInicialEdit} onChange={handleChangeEditValorInicial}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="rentabilidad" label="Rentabilidad" variant="outlined" value={rentabilidadEdit} onChange={handleChangeEditRentabilidad}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de inicio" value={fechaDeInicioEdit} onChange={handleChangeEditFechaDeInicio}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="plazo" label="Plazo" variant="outlined" value={plazoEdit} onChange={handleChangeEditPlazo}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de finalización" value={fechaDeFinalizacionEdit} onChange={handleChangeEditFechaDeFinalizacion}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="pago-de-rendimientos" label="Pago de rendimientos" variant="outlined" value={pagoDeRendimientosEdit} onChange={handleChangeEditPagoDeRendimientos}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={2} textAlign={'center'}>
                                <ButtonAdd type="submit">Editar fondeador</ButtonAdd>
                            </Box>
                        </form>
                    </Box>
                </Modal>
            }
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdrop}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleClosedSnack}>
                <Alert onClose={handleClosedSnack} severity={severity} sx={{width: '100%'}}>{message}</Alert>
            </Snackbar>
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdropEdit}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={openSnackbarEdit} autoHideDuration={5000} onClose={handleClosedSnakcbarEdit}>
                <Alert onClose={handleClosedSnakcbarEdit} severity={severityEdit} sx={{width: '100%'}}>{messageEdit}</Alert>
            </Snackbar>
        </React.Fragment>
    )
}